export default () => {
    return (
        <div className="bg-black overflow-hidden pb-32">
            <div className="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                <div className="hidden lg:block bg-black absolute top-0 bottom-0 left-3/4 w-screen" />
                <div className="mx-auto lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none">
                    <h2 className="mt-2 text-5xl text-white font-custom italic font-bold uppercase">
                        Over de auteur{" "}
                    </h2>
                </div>
                <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
                    <div className="relative lg:row-start-1 lg:col-start-2">
                        <div className="relative text-base mx-auto max-w-prose lg:max-w-none">
                            <div className="aspect-w-12 aspect-h-7 lg:aspect-none">
                                <picture>
                                    <source
                                        srcSet="/assets/webp/auteur-succesvol-afvallen-zonder-voedingsschema.webp"
                                        width={1184}
                                        height={1376}
                                        type="image/webp"
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                    <source
                                        srcSet="/assets/auteur-succesvol-afvallen-zonder-voedingsschema.jpg"
                                        width={1184}
                                        height={1376}
                                        type="image/jpeg"
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                    <img
                                        src="/assets/auteur-succesvol-afvallen-zonder-voedingsschema.jpg"
                                        width={1184}
                                        height={1376}
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="mt-8 lg:mt-0">
                        <div className="text-base max-w-prose mx-auto lg:max-w-none">
                            <p className="text-lg text-gray-100">
                                Thierry van Melis is een ondernemer,
                                gecertificeerd trainer en fanatieke
                                krachtsporter. Hij bedacht in 2015 een uniek
                                concept dat uitgroeide tot een formule waarmee
                                hij al meer dan 750 mensen heeft geholpen om hun
                                onzekerheid om te buigen naar zelfvertrouwen.
                                Met zijn methode helpt hij mensen die worstelen
                                om hun doelen te bereiken naar een duurzaam
                                fysiek en mentaal resultaat.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
